import { FormattedMessage } from "react-intl";
import { Typography } from "antd";

const CustomTitle = ({ id, level, defaultMessage }) => (
  <Typography.Title level={level || 4}>
    <FormattedMessage id={id} defaultMessage={defaultMessage} />
  </Typography.Title>
);

export default CustomTitle;
